import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';

var _templateObject = _taggedTemplateLiteral(['\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  flex: 1;\n  white-space: nowrap;\n'], ['\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  flex: 1;\n  white-space: nowrap;\n']);

import React, { Component } from 'react';
import styled from 'styled-components';
import { components } from 'react-select';
import RadioIcon from '@atlaskit/icon/glyph/radio';
import CheckboxIcon from '@atlaskit/icon/glyph/checkbox';
import { colors, themed } from '@atlaskit/theme';


// maintains function shape
var backgroundColor = themed({ light: colors.N40A, dark: colors.DN10 });
var transparent = themed({ light: 'transparent', dark: 'transparent' });

// state of the parent option


// the primary color represents the outer or background element
var getPrimaryColor = function getPrimaryColor(_ref) {
  var isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      rest = _objectWithoutProperties(_ref, ['isActive', 'isDisabled', 'isFocused', 'isSelected']);

  var color = backgroundColor;
  if (isDisabled && isSelected) {
    color = themed({ light: colors.B75, dark: colors.DN200 });
  } else if (isDisabled) {
    color = themed({ light: colors.N20A, dark: colors.DN10 });
  } else if (isActive) {
    color = themed({ light: colors.B75, dark: colors.B200 });
  } else if (isFocused && isSelected) {
    color = themed({ light: colors.B300, dark: colors.B75 });
  } else if (isFocused) {
    color = themed({ light: colors.N50A, dark: colors.DN30 });
  } else if (isSelected) {
    color = colors.blue;
  }
  // $FlowFixMe: TEMPORARY
  return color(rest);
};

// the secondary color represents the radio dot or checkmark
var getSecondaryColor = function getSecondaryColor(_ref2) {
  var isActive = _ref2.isActive,
      isDisabled = _ref2.isDisabled,
      isSelected = _ref2.isSelected,
      rest = _objectWithoutProperties(_ref2, ['isActive', 'isDisabled', 'isSelected']);

  var color = themed({ light: colors.N0, dark: colors.DN10 });

  if (isDisabled && isSelected) {
    color = themed({ light: colors.N70, dark: colors.DN10 });
  } else if (isActive && isSelected && !isDisabled) {
    color = themed({ light: colors.B400, dark: colors.DN10 });
  } else if (!isSelected) {
    color = transparent;
  }
  // $FlowFixMe: TEMPORARY
  return color(rest);
};

var ControlOption = function (_Component) {
  _inherits(ControlOption, _Component);

  function ControlOption() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, ControlOption);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = ControlOption.__proto__ || _Object$getPrototypeOf(ControlOption)).call.apply(_ref3, [this].concat(args))), _this), _this.state = { isActive: false }, _this.onMouseDown = function () {
      return _this.setState({ isActive: true });
    }, _this.onMouseUp = function () {
      return _this.setState({ isActive: false });
    }, _this.onMouseLeave = function () {
      return _this.setState({ isActive: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ControlOption, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          getStyles = _props.getStyles,
          Icon = _props.Icon,
          isDisabled = _props.isDisabled,
          isFocused = _props.isFocused,
          isSelected = _props.isSelected,
          children = _props.children,
          innerProps = _props.innerProps,
          rest = _objectWithoutProperties(_props, ['getStyles', 'Icon', 'isDisabled', 'isFocused', 'isSelected', 'children', 'innerProps']);

      var isActive = this.state.isActive;

      // styles

      var bg = 'transparent';
      if (isFocused) bg = colors.N20;
      if (isActive) bg = colors.B50;

      var style = {
        alignItems: 'center',
        backgroundColor: bg,
        color: 'inherit',
        display: 'flex '
      };

      // prop assignment
      var props = _extends({}, innerProps, {
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        onMouseLeave: this.onMouseLeave,
        style: style
      });

      return React.createElement(
        components.Option,
        _extends({}, rest, {
          isDisabled: isDisabled,
          isFocused: isFocused,
          isSelected: isSelected,
          getStyles: getStyles,
          innerProps: props
        }),
        React.createElement(Icon, {
          primaryColor: getPrimaryColor(_extends({}, this.props, this.state)),
          secondaryColor: getSecondaryColor(_extends({}, this.props, this.state))
        }),
        React.createElement(
          Truncate,
          null,
          children
        )
      );
    }
  }]);

  return ControlOption;
}(Component);
/* TODO:
  to be removed
  the label of an option in the menu
  should ideally be something we can customise
  as part of the react-select component API
  at the moment we are hardcoding it into
  the custom input-option components for Radio and Checkbox Select
  and so this behaviour is not customisable / disableable
  by users who buy into radio / checkbox select.
*/

var Truncate = styled.div(_templateObject);

export var CheckboxOption = function CheckboxOption(props) {
  return React.createElement(ControlOption, _extends({ Icon: CheckboxIcon }, props));
};
export var RadioOption = function RadioOption(props) {
  return React.createElement(ControlOption, _extends({ Icon: RadioIcon }, props));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/select/dist/esm/components/input-options.js
// module id = 495
// module chunks = 0